export const AdminBoardTagController = {
    index(): void {},
    store(): void {},
    reorder(): void {},
    update(): void {},
    destroy(): void {},
};
